import React from "react";

const Spinner = (props) => {
  return (
    <div class="flex justify-center items-center mt-5">
      <div
        class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-indigo-500"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
